module.exports = __webpack_public_path__ + "static/media/spain.0c0cfe47.svg";